import { TextField } from '@mui/material';
import NumericFormatCustom from './NumericFormatCustom';

const NumericInputField = ({ currentFilter, setCurrentFilter }) => (
	<TextField
		sx={{ fontSize: '14px' }}
		label="Value"
		value={currentFilter.value ?? ''}
		onChange={(e) => {
			setCurrentFilter({ ...currentFilter, value: e.target.value });
		}}
		name="numberformat"
		id="formatted-numberformat-input"
		InputProps={{
			inputComponent: NumericFormatCustom
		}}
		variant="standard"
	/>
);

export default NumericInputField;
